import React, { PureComponent } from 'react';
import { Switch, Route } from 'react-router-dom';
import Dashboard from 'containers/Dashboard';
import Login from 'containers/Auth/Login';

class RoutesContainer extends PureComponent {
  render() {
    return (
      <Switch>
        <Route path="/dashboard/:pageType" component={Dashboard} />
        <Route path="/" component={Login} />
      </Switch>
    );
  }
}

export default RoutesContainer;
